/** SMB: баннер «Впервые на Циан» */
export const PROMO_LINK = 'https://www.cian.ru/cian_new/?utm_source=guide&utm_medium=smb&utm_campaign=banner';

/** SMB: PreFooter — разместить объявление */
export const ADD_ADVERT =
  'https://www.cian.ru/razmestit-obyavlenie/?utm_source=guide&utm_medium=smb&utm_campaign=banner';

/** Баннер «Размещайтесь на Циан» */
export const PLACE_ON_CIAN_LINK = 'https://www.cian.ru/razmestit-obyavlenie/';

/** SOB: подбор риелтора */
export const REALTOR_SELECTION_LINK = 'https://www.cian.ru/podbor-rieltora/?cian_source=guide';

/** SOB: Циан × ПИК-Аренда */
export const PIK_ARENDA_LINK = 'https://www.cian.ru/pik-arenda/';

/** Host: онлайн-бронирование */
export const ONLINE_BOOKING_LINK = 'https://promo.cian.site/online_booking';

/** Host-гайд (посуточно), прод-URL по умолчанию */
export const HOST_GUIDE_URL = 'https://www.cian.ru/guide/posutochno';

/** SOB: статья про ошибки при продаже квартиры */
export const SOB_GUIDE_SALE_APARTMENT_ARTICLE_LINK =
  'https://spb.cian.ru/stati-shest-oshibok-sobstvennika-pri-prodazhe-kvartiry-336018/?cian_source=guide';

/** SOB: статья про эстетичный интерьер */
export const SOB_GUIDE_INTERIOR_ARTICLE_LINK =
  'https://spb.cian.ru/stati-kak-sozdat-estetichnyj-interer-chtoby-obustroit-legko-prodat-ili-sdat-zhile-333555/?cian_source=guide';
